<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-3px border-bottom padding-right-7px padding-left-8px padding-top-3px">

        <div class="row">
          <div class="col-md-10">
            <label class="margin-bottom-0px">
              Add/Edit Treatment Category
            </label>
          </div>
          <div class="col-md-2 float-right text-align-right">

            <button type="button" class="close float-right" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>

          </div>



        </div>



      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-3px">
        <div class="row">
          <div class="col-md-12">
            <h4 class="margin-bottom-3px font-size-16px color-Assign font-weight-bold">{{AdmissionService.PatientName}}</h4>
          </div>
         
        </div>
        <div class="row font-size-12px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5   padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">AdmissionNo </label>
              </div>:
              <div class="col-md-5 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AdmissionService.AdmissionNo}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Branch </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AdmissionService.BranchName}}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row font-size-12px border-bottom-1px">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-5   padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Admission Dt </label>
              </div>:
              <div class="col-md-5 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AdmissionService.AdmissionDate | date:'dd-MMM-yyyy'}}</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4  text-align-right padding-right-5px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Room/Ward </label>
              </div>:
              <div class="col-md-7 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{AdmissionService.CareUnit}}/{{AdmissionService.BedLocation}}</label>
              </div>
            </div>
          </div>
        </div>
        <form class="form" novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">
                <div class="row margin-top-3px">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row margin-bottom-3px">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-3px">Current Treatment Category</label>
                      </div>:
                      <div class="col-md-5">
                        <h4 class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold font-size-16px">{{AdmissionService.TreatmentCategory}}</h4>
                        
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-5 text-align-right padding-left-0px">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Change To</label>
                      </div>
                      <div class="col-md-5">
                        <CodeTypeValue CodeType="ATCTY" id="TrCat" class="form-control"
                                       [(ngModel)]="AdmissionService.TreatmentCategory" SelectedValue=""
                                       name="TrCat">
                        </CodeTypeValue>
                        <!--<CodeTypeValue CodeType="ATCTY" id="CurrentSavePaymentModeInfoRequest.ChangeToPayMode"
                                       [(ngModel)]="CurrentSavePaymentModeInfoRequest.ChangeToPayMode" SelectedValue=""
                                       name="CurrentSavePaymentModeInfoRequest.ChangeToPayMode">
                        </CodeTypeValue>-->

                      </div>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" (click)="activeModal.close(AdmissionService)" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
